import React, { useEffect, useState } from 'react';
import { scrollToForm, scrollToId } from '../utils/scroll';
import { LOGO_URL } from '../data/brand';
const links = [{
  label: 'La oportunidad',
  id: 'oportunidad'
}, {
  label: '¿Es para mí?',
  id: 'perfil'
}, {
  label: 'Preguntas',
  id: 'preguntas'
}];
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ease-out ${scrolled ? 'bg-ink/95 backdrop-blur-sm' : 'bg-transparent'}`} data-id="element-140" data-mp="1pp8lw0yey1y8">
      <div className="mx-auto flex h-16 max-w-page items-center justify-between px-5 sm:h-20 sm:px-8 lg:px-12" data-id="element-141" data-mp="1yqghucdgiqp5">
        <button type="button" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} className="flex items-center transition-opacity duration-200 ease-out hover:opacity-80" aria-label="EXPANDE — Tu visión. Tus posibilidades. Ir al inicio" data-id="element-142" data-mp="23oi41666j64u">
          <img src={LOGO_URL} alt="EXPANDE — Tu visión. Tus posibilidades." className="h-auto w-[110px] sm:w-[132px]" data-id="element-143" data-mp="1p4gy9eeac8uu" />
        </button>

        <nav aria-label="Principal" className="flex items-center gap-8" data-id="element-144" data-mp="2hto6j53jkcta">
          <ul className="hidden items-center gap-8 lg:flex" data-id="element-145" data-mp="2hvqvdlsyjzwf">
            {links.map(link => <li key={link.id} data-id="element-146" data-mp="2cx773eqw6c0w">
                <button type="button" onClick={() => scrollToId(link.id)} className="font-sans text-[13px] font-light text-ivory/80 transition-colors duration-200 ease-out hover:text-champagne" data-id="element-147" data-mp="283l288qyzcfn">
                  {link.label}
                </button>
              </li>)}
          </ul>

          <button type="button" onClick={scrollToForm} className="whitespace-nowrap border border-champagne px-4 py-2.5 font-sans text-[10px] font-medium uppercase tracking-[0.18em] text-champagne transition-colors duration-200 ease-out hover:bg-champagne hover:text-ink sm:px-6 sm:py-3 sm:text-[11px]" data-id="element-148" data-mp="2vrvyeylq0nxl">
            Agendar conversación
          </button>
        </nav>
      </div>
    </header>;
}